import { z } from "zod";

/**
 * ObraEstruturaOrganizacionalSchema
 */

export const ObraEstruturaOrganizacionalSchema = z.object({
  idFuncionario: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  idCargo: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  cargo: z.string(),
});

/**
 * ObraEstruturaOrganizacionalForm
 */

export type ObraEstruturaOrganizacionalForm = z.infer<typeof ObraEstruturaOrganizacionalSchema>;